export enum GetWorkersTypes {
  SEARCH_WORKERS_CONFIG = '[Workers] Search Workers',
  SEARCH_WORKERS_CONFIG_SUCCESS = '[Workers] Search Workers Success',
  SEARCH_WORKERS_CONFIG_ERROR = '[Workers] Search Workers Error',
}

type GetWorkersConfiguration = {
  type: typeof GetWorkersTypes.SEARCH_WORKERS_CONFIG;
};
type GetWorkersConfigurationSuccess = {
  type: typeof GetWorkersTypes.SEARCH_WORKERS_CONFIG_SUCCESS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: { data: any[] };
};
type GetWorkersConfigurationError = {
  type: typeof GetWorkersTypes.SEARCH_WORKERS_CONFIG_ERROR;
  payload: { error: string };
};

export type WorkersActionTypes =
  | GetWorkersConfiguration
  | GetWorkersConfigurationSuccess
  | GetWorkersConfigurationError;

export const WorkersActionsTypes = {
  getWorkersInfo: (): GetWorkersConfiguration => ({
    type: GetWorkersTypes.SEARCH_WORKERS_CONFIG,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getWorkersInfoSuccess: (data: any[]): GetWorkersConfigurationSuccess => ({
    type: GetWorkersTypes.SEARCH_WORKERS_CONFIG_SUCCESS,
    payload: { data },
  }),
  getWorkersInfoError: (error: string): GetWorkersConfigurationError => ({
    type: GetWorkersTypes.SEARCH_WORKERS_CONFIG_ERROR,
    payload: { error },
  }),
};
